import { DataFormat } from './enums';

export default {
    dataFormat: DataFormat.AUTO
};
